module.exports = __webpack_public_path__ + "media/images/emblems/Chur_wappen-c07b4139710c4df9601225173c05cd24.svg";